import type { TileQueryRequest } from "@csbi/contracts"

export function createTileFingerprint(req: TileQueryRequest): string {
  const range = "preset" in req.range ? req.range.preset : `${req.range.from}~${req.range.to}`
  return [
    req.metrics.join("+"),
    [...req.tenantIds].sort().join(","),
    [...req.environments].sort().join(","),
    req.includeChurned ? "churned" : "",
    range,
    req.granularity,
    req.splitBy.join("/"),
    req.topN ?? "",
    req.comparePrevious ? "pop" : "",
  ].join("|")
}
